<template>
    <div class="font-sans">
        <router-view :key="$route.path" />
        <!-- <router-view v-slot="{ Component  }">
            <template v-if="$route.name==='privilege' || $route.name==='campaign'">
                <KeepAlive>
                    <component :is="Component" />
                </KeepAlive>
            </template>
            <template v-else>
                <component :is="Component" />
            </template>
        </router-view> -->
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager.js";

export default {
    created: function () {
        console.log(this.$router.currentRoute.path)
        console.log("run local environment", ConfigManager.getApi());
    },
}
</script>
